import { useIsPC } from '~/lib/ua'
import type { Item, SubItem } from './data/type'

export function useItemsByDeviceType<T extends Item | SubItem>(items: T[]): T[] {
  const targetDevice = useIsPC() ? 'pc' : 'sd'
  return items.filter(
    (item) => item.targetDevice === undefined || item.targetDevice === targetDevice
  )
}
